<template>
  <div v-if="socialresponsibility !== null">
    <!-- 社會責任 -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="socialresponsibility.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Tab -->
      <div class="form-item d-flex py-5" v-if="TabShow">
        <div class="w-240px mr-5">
          <h4>Tab</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="選擇Tab"
            :isOnlyShowButtonPlaceholder="true"
            buttonWidth="160px"
            modalWidth="200px"
            :options="srTypeOptions"
            :selectedValue.sync="socialresponsibility.tab"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="socialresponsibility.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="socialresponsibility.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 夾圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">夾圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於列表文下方的圖檔 <br />
            建議尺寸：1366px * 420px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="socialresponsibility.cover_image"
            dir="SocialResponsibility"></ImgUploader>
        </div>
      </div>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="socialresponsibility.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Summary -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Summary</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-textarea
            v-model="socialresponsibility.summary"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="socialresponsibility.content"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    FormSwitch,
    ImgUploader,
    Editor,
  },
  data: () => ({
    tab: '',
    status: true,
    TabShow: false,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('socialresponsibility', ['socialresponsibility', 'srTypeOptions']),
  },
};
</script>

<style></style>
